import { render, staticRenderFns } from "./add.vue?vue&type=template&id=d080cc2c&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=d080cc2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d080cc2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-airdrop-manager-fe/treasurenet-tnservices-airdrop-manager-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d080cc2c')) {
      api.createRecord('d080cc2c', component.options)
    } else {
      api.reload('d080cc2c', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=d080cc2c&scoped=true", function () {
      api.rerender('d080cc2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/airdropPlan/add.vue"
export default component.exports